import { helper } from "@ember/component/helper"
import PrismicDOM from "prismic-dom"

export function prismicAsHtml(params /*, hash*/) {
  return PrismicDOM.RichText.asHtml(params[0] || [])
}

export default helper(prismicAsHtml)
